export const getFieldName = column => {
  let fieldName = column.name;
  if (column.index && column.index > 1) {
    fieldName = `${fieldName}_${column.index}`;
  }
  return fieldName;
};
